import Vue from 'vue';
import stringify from 'json-stringify-pretty-compact';
import jsonminify from 'jsonminify';
import { guid } from '@/mixins/guid';
import dropsLoader from '@/mixins/components/drops-loader';

export default Vue.component('raw-site-data', {
  template: require('./template.html'),
  name: 'raw-site-data',
  mixins: [guid],
  components: {
    dropsLoader,
  },
  props: ['modal', 'current-site', 'toggle-modal'],
  data() {
    return {
      loading: false,
      rawData: '',
      initialData: '',
      rawJSON: {},
      siteJSON: {},
      selectedPage: '',
      selectedTemplate: '',
      selectedDraft: '',
      selectedRecycled: '',
      itemLoaded: false,
    };
  },
  watch: {
    modal(o) {
      if (o) {
        this.loadRawSelected();
      }
    },
  },
  methods: {
    async loadRawSelected(params) {
      this.loading = true;
      try {
        const get = await this.$lightning([{
          name: 'getRawWebsite',
          payload: {
            siteId: this.currentSite._id,
            fetch: params,
          },
        }]);
        this.rawJSON = get.data;
        this.siteJSON = get.data;
        this.rawData = stringify(get.data);
        this.initialData = this.rawData;
        if (!params) {
          this.itemLoaded = false;
        } else {
          this.itemLoaded = params.type.replace(/s$/, '');
        }
      } catch (e) {
        this.$log.error(e.message || e);
      } finally {
        this.loading = false;
      }
    },
    cancelChanges() {
      this.rawData = this.initialData;
    },
    validateJSON(dump) {
      return new Promise((resolve, reject) => {
        try {
          JSON.parse(dump);
          if (dump === '' || dump === '"{}"') {
            throw new Error('Input cannot be empty.');
          }
          resolve(true);
        } catch (e) {
          reject(e.message || e);
        }
      });
    },
    async saveChanges() {
      this.loading = true;
      const notification = {
        id: this.guid(),
        type: 'success',
        message: 'Data saved successfully!',
      };
      try {
        const dump = jsonminify(this.rawData);
        await this.validateJSON(dump);
        await this.$lightning([{
          name: 'saveRawData',
          payload: {
            siteId: this.currentSite._id,
            itemLoaded: this.itemLoaded,
            itemId: this.rawJSON._id,
            dump,
          },
        }]);
        this.initialData = this.rawData;
      } catch (e) {
        const message = e.message || e;
        this.$log.error(message);
        notification.type = 'error';
        notification.message = message;
      } finally {
        this.loading = false;
        this.$store.dispatch('addNotification', notification);
      }
    },
    closeModal(type) {
      this.$emit('toggle-modal', type, 'child');
    },
  },
});



// WEBPACK FOOTER //
// ./src/storm/admin/raw-site-data/index.js